import React from 'react';

const PrestationWithCode = () => (
  <section>
    <p>
      Recordá ingresar el código de prestación de lo que necesitas autorizar. Si no requiere
      autorización previa, obtenés respuesta al instante del trámite.
    </p>
    <p>¡Muchas gracias!</p>
  </section>
);

export default PrestationWithCode;
